import React from 'react'
import './Loader.css'

function Loader() {
   return (
      <div className="spinner">
         <span></span>
         <span></span>
         <span></span>
         <span></span>
         <span></span>
         <span></span>
         <span></span>
         <span></span>
      </div>
   )
}

export default Loader
